import { render } from "./TrashCanOutlineIcon.vue?vue&type=template&id=009b9a88"
import script from "./TrashCanOutlineIcon.vue?vue&type=script&lang=js"
export * from "./TrashCanOutlineIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__